import { createFileRoute } from '@tanstack/react-router';
import { BillingPage } from '../../features/billing';

export const Route = createFileRoute('/portal/billing/')({
  // `?checkout=success|cancelled` is where Stripe Checkout sends the owner back.
  validateSearch: (s: Record<string, unknown>): { checkout?: 'success' | 'cancelled' } =>
    s.checkout === 'success' || s.checkout === 'cancelled' ? { checkout: s.checkout } : {},
  component: function BillingRoute() {
    const { checkout } = Route.useSearch();
    return <BillingPage checkout={checkout} />;
  },
});
